<template>
  <div class="reset-page">
    <div class="login-container">
      <header class="header mb-3 text-center">
        <img :src="logoUrl" alt="Logomarca" class="logo" />
        <h6>Redefinir Senha</h6>
      </header>

      <form @submit.prevent="submit" class="reset-form">
        <!-- Nova senha -->
        <div class="form-group">
          <label for="password">Nova senha</label>
          <div class="input-with-icon">
            <input
              id="password"
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              class="form-control pe-5"
              required
              autocomplete="new-password"
            />
            <button
              type="button"
              class="toggle-visibility"
              :aria-pressed="showPassword ? 'true' : 'false'"
              :title="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
              @click="showPassword = !showPassword"
            >
              <i :class="showPassword ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
            </button>
          </div>
        </div>

        <!-- Confirmar senha -->
        <div class="form-group">
          <label for="confirmPassword">Confirmar senha</label>
          <div class="input-with-icon">
            <input
              id="confirmPassword"
              :type="showConfirm ? 'text' : 'password'"
              v-model="confirmPassword"
              class="form-control pe-5"
              required
              autocomplete="new-password"
            />
            <button
              type="button"
              class="toggle-visibility"
              :aria-pressed="showConfirm ? 'true' : 'false'"
              :title="showConfirm ? 'Ocultar senha' : 'Mostrar senha'"
              @click="showConfirm = !showConfirm"
            >
              <i :class="showConfirm ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
            </button>
          </div>

          <div v-if="confirmPassword && !passwordsMatch" class="text-danger small">
            As senhas não coincidem.
          </div>
        </div>

        <div v-if="message" :class="['alert', messageType]">
          {{ message }}
        </div>

        <button
          type="submit"
          class="btn btn-primary w-100"
          :disabled="isSubmitting || !passwordsMatch"
        >
          {{ isSubmitting ? 'Processando…' : 'Redefinir Senha' }}
        </button>
      </form>

      <footer class="footer text-center mt-3">
        <p>&copy; {{ new Date().getFullYear() }} - TOQ Soluções / Khodr & Cabral</p>
        <a href="#">Termos de uso</a>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import api from '@/services/axios';

// Rota/Router
const route = useRoute();
const router = useRouter();

// Token: mantenha como no seu fluxo original
const token = route.query.token || '';

// Form state
const password = ref('');
const confirmPassword = ref('');
const isSubmitting = ref(false);
const message = ref('');
const messageType = ref('alert-success');
const showPassword = ref(false);
const showConfirm = ref(false);

const passwordsMatch = computed(() => password.value === confirmPassword.value);

// === LOGOMARCA via endpoint BYTEA ===
// Base da API: prioriza a baseURL da instância do axios; senão, env; senão, '/api'
// function resolveApiBase() {
//   const instBase = api?.defaults?.baseURL;
//   if (instBase) return instBase;
//   const envVite = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};
//   return envVite.VITE_API_BASE_URL || process.env.VUE_APP_API_URL || '/api';
// }

const { proxy } = getCurrentInstance()
const logoUrl = computed(() => proxy?.$globalState?.logoPath || '')

// Fallback visual caso a imagem não carregue
// function onImgError(e) {
//   e.target.src =
//     "data:image/svg+xml;utf8," +
//     encodeURIComponent(
//       `<svg xmlns='http://www.w3.org/2000/svg' width='240' height='80'>
//          <rect width='100%' height='100%' fill='#f2f2f2'/>
//          <text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle'
//                font-family='sans-serif' font-size='14' fill='#888'>
//            sem logomarca
//          </text>
//        </svg>`
//     );
// }

// Submit
async function submit() {
  if (!passwordsMatch.value) return;
  isSubmitting.value = true;
  message.value = '';

  try {
    const res = await api.post('/auth/reset-password', {
      token, // inalterado
      newPassword: password.value,
    });

    messageType.value = 'alert-success';
    message.value = res?.data?.message || 'Senha redefinida com sucesso.';
    setTimeout(() => router.push('/login'), 2000);
  } catch (err) {
    messageType.value = 'alert-danger';
    message.value =
      err?.response?.data?.message ||
      err?.message ||
      'Token inválido ou expirado.';
  } finally {
    isSubmitting.value = false;
  }
}
</script>


<style scoped>
.reset-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: blur(5px);
  z-index: -1;
}
.login-container {
  background: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 100%;
}
.logo {
  width: 150px;
  margin-bottom: 10px;
}
.reset-form .form-group {
  margin-bottom: 15px;
  text-align: left;
}
.reset-form label {
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
}
.reset-form input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.btn-primary {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.footer {
  font-size: 12px;
  color: #777;
}
.footer a {
  color: #007bff;
  text-decoration: none;
  font-size: 12px;
}
.footer a:hover {
  text-decoration: underline;
}
.input-with-icon { position: relative; }

.input-with-icon .toggle-visibility {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  padding: 0;
  line-height: 1;
  cursor: pointer;
}

.input-with-icon .toggle-visibility i { font-size: 1.1rem; }

/* garante espaço para o ícone à direita */
.form-control.pe-5 { padding-right: 2.5rem !important; }

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Tamanho padrão da logo no card */
.logo {
  display: block;
  max-width: 100%;
  height: 100px;        /* ajuste aqui o “quão grande” quer */
  width: auto;         /* mantém proporção */
  object-fit: contain; /* não distorce se a imagem for alta/larga */
  margin-bottom: 10px;
}

/* Opcional: ajuste para telas pequenas */
@media (max-width: 768px) {
  .logo {
    height: 48px;
  }
}

</style>